(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-expediente-juridicos-informes", {
                parent: "entity",
                url: "/consortium-expediente-juridicos-informes?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoInforme",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes.html",
                        controller: "ConsortiumExpedienteJuridicoInformeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-informes.new", {
                parent: "consortium-expediente-juridicos-informes",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes-new.html",
                        controller: "ConsortiumExpedienteJuridicoInformeNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-expediente-juridicos-informes",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-informes",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-informes.edit", {
                parent: "consortium-expediente-juridicos-informes",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoInforme",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes-detail.html",
                        controller: "ConsortiumExpedienteJuridicoInformeDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-expediente-juridicos-informes",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumExpedienteJuridicoInforme",
                        function (
                            $stateParams,
                            ConsortiumExpedienteJuridicoInforme
                        ) {
                            return ConsortiumExpedienteJuridicoInforme.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-informes",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();
